import React from "react";

import { Box, BoxProps } from "../../components/Box";

export type PageContainerProps = BoxProps;

export const PageContainer: React.FC<PageContainerProps> = (styledProps) => {
  return (
    <Box
      as="main"
      id="maincontent"
      bg="#FAFAFA"
      mx="auto"
      my="0"
      {...styledProps}
    />
  );
};

PageContainer.displayName = "PageContainer";

export default PageContainer;
